import { PERIODS, type Period } from '../../utils/analytics'

/** Segmented Day/Week/Month/Year selector shared by the Snapshot and Analytics. */
export default function PeriodToggle({
  value,
  onChange,
}: {
  value: Period
  onChange: (p: Period) => void
}) {
  return (
    <div className="flex overflow-hidden rounded-lg border border-[var(--border)] text-xs">
      {PERIODS.map((p) => (
        <button
          key={p.key}
          onClick={() => onChange(p.key)}
          className={`px-3 py-1 transition-colors ${
            value === p.key
              ? 'bg-[var(--accent-teal)] font-semibold text-[var(--bg-primary)]'
              : 'text-[var(--text-secondary)] hover:bg-[var(--bg-card)]'
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  )
}
